import { Icon, IconName } from '@usealloy/component-library';
import React from 'react';

import { getIconColorForBackgroundColor } from 'flow/editor/components/helpers';
import type { OutcomeReasonNode as IOutcomeReasonNode, WorkflowNodeProps } from 'flow/service/graph';

import BaseNode from '../BaseNode';
import { StyledIconWrapper } from './styles';


function OutcomeReasonNode(props: WorkflowNodeProps<IOutcomeReasonNode>) {
  const {
    id,
    type,
    data: {
      color, label,
    },
  } = props;

  const iconColor = getIconColorForBackgroundColor(color);

  return (
    <BaseNode
      icon={(
        <StyledIconWrapper backgroundColor={color}>
          <Icon color={iconColor} icon={IconName.Stamp} size="small" />
        </StyledIconWrapper>
      )}
      id={id}
      label={label}
      stateStyle={{
        baseBackgroundColor: 'var(--cl-gray-300)',
        highlighted: {
          backgroundColor: 'var(--cl-gray-400)',
        },
        hovered: {
          backgroundColor: 'var(--cl-gray-400)',
        },
      }}
      type={type}
    />
  );
}

export default React.memo(OutcomeReasonNode);
